var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "report-wrapper" }, [
        _c("p", { staticClass: "time_range" }, [
          _vm._v(
            _vm._s(_vm.formatTime(_vm.data.start_time)) +
              " - " +
              _vm._s(_vm.formatTime(_vm.data.end_time))
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "report_name" }, [
          _vm._v(_vm._s(_vm.data.course_name) + _vm._s(_vm.data.report_name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info_detail" }, [
          _vm.showmore
            ? _c(
                "p",
                { staticClass: "prev", on: { click: _vm.changeReport } },
                [
                  _c("img", {
                    attrs: { src: require("../../../static/images/prev.png") }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showmore
            ? _c(
                "p",
                { staticClass: "next", on: { click: _vm.changeReport } },
                [
                  _c("img", {
                    attrs: { src: require("../../../static/images/next.png") }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "head_portrait",
            attrs: { src: _vm.data.head_portrait }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "user_name" }, [
            _vm._v(_vm._s(_vm.data.user_name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statistics" }, [
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("学习总时长")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.data.learning_statistics.live_learning_time)
                    )
                  ]),
                  _vm._v("小时")
                ]),
                _vm._v(" "),
                _vm.data.total_learning_statistics
                  ? _c("span", { staticClass: "total_time" }, [
                      _vm._v(
                        "累计时长" +
                          _vm._s(
                            _vm.data.total_learning_statistics
                              .live_learning_time
                          ) +
                          "小时"
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "borders" }),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("学习总天数")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [_vm._v(_vm._s(_vm.data.learning_statistics.days))]),
                  _vm._v("天")
                ]),
                _vm._v(" "),
                _vm.data.total_learning_statistics
                  ? _c("span", { staticClass: "total_time" }, [
                      _vm._v(
                        "累计天数" +
                          _vm._s(_vm.data.total_learning_statistics.days) +
                          "天"
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "borders" }),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("课件完成数")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.data.learning_statistics.course_num))
                  ]),
                  _vm._v("个")
                ]),
                _vm._v(" "),
                _vm.data.total_learning_statistics
                  ? _c("span", [
                      _vm._v(
                        "累计完成" +
                          _vm._s(
                            _vm.data.total_learning_statistics.course_num
                          ) +
                          "个"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.data.class_teacher_msg.question ||
        _vm.data.class_teacher_msg.suggest ||
        _vm.data.lecturer_msg.question ||
        _vm.data.lecturer_msg.suggest ||
        _vm.data.assistant_msg.question ||
        _vm.data.assistant_msg.suggest
          ? _c("div", { staticClass: "message_detail" }, [
              _vm._m(1),
              _vm._v(" "),
              _vm.data.class_teacher_msg.question ||
              _vm.data.class_teacher_msg.suggest
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title font_bold" }, [
                      _vm._v("班主任")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.class_teacher_msg.question)
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.class_teacher_msg.suggest)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.lecturer_msg.question || _vm.data.lecturer_msg.suggest
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title font_bold" }, [
                      _vm._v("讲师")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.lecturer_msg.question)
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.lecturer_msg.suggest)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.assistant_msg.question || _vm.data.assistant_msg.suggest
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title font_bold" }, [
                      _vm._v("助教老师")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.assistant_msg.question)
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.assistant_msg.suggest)
                      }
                    })
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "live_detail" }, [
          _c("p", { staticClass: "live_title" }, [
            _c("span", { staticClass: "icon" }, [
              _c("img", {
                attrs: { src: require("../../../static/images/live.png") }
              }),
              _vm._v("直播\n        "),
              _c("span", { staticClass: "supplementary" }, [
                _vm._v(
                  "周期内共" +
                    _vm._s(_vm.data.learning_statistics.live_num) +
                    "节直播,出勤" +
                    _vm._s(_vm.data.learning_statistics.live_attendance_num) +
                    "节"
                )
              ])
            ]),
            _vm._v(" "),
            _vm.data.learning_statistics.live_num
              ? _c(
                  "span",
                  { staticClass: "godetail", on: { click: _vm.goToLive } },
                  [
                    _vm._v("详情"),
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/detail.png")
                      }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "partition_statistics" }, [
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("课程完成数")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.live_attendance_num) +
                    "/" +
                    _vm._s(_vm.data.learning_statistics.live_num)
                )
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计完成" +
                        _vm._s(
                          _vm.data.total_learning_statistics.live_attendance_num
                        ) +
                        "/" +
                        _vm._s(_vm.data.total_learning_statistics.live_num)
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("直播观看时长")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(_vm._s(_vm.data.learning_statistics.live_learning_time)),
                _c("span", { staticClass: "hours" }, [_vm._v("小时")])
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计时长" +
                        _vm._s(
                          _vm.data.total_learning_statistics.live_learning_time
                        ) +
                        "时"
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("回放净观看时长")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.playback_learning_time)
                ),
                _c("span", { staticClass: "hours" }, [_vm._v("小时")])
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计时长" +
                        _vm._s(
                          _vm.data.total_learning_statistics
                            .playback_learning_time
                        ) +
                        "时"
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "video_detail" }, [
          _c("p", { staticClass: "live_title" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "godetail", on: { click: _vm.goVideo } },
              [
                _vm._v("详情"),
                _c("img", {
                  attrs: { src: require("../../../static/images/detail.png") }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "partition_statistics" }, [
            _c("div", { staticClass: "canvas" }, [
              _c("p", { staticClass: "cumulative_duration" }, [
                _vm._v("完成数")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.video_finish_total) +
                    "/" +
                    _vm._s(_vm.data.learning_statistics.video_total)
                )
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计完成" +
                        _vm._s(
                          _vm.data.total_learning_statistics.video_finish_total
                        ) +
                        "/" +
                        _vm._s(_vm.data.total_learning_statistics.video_total)
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas" }, [
              _c("p", { staticClass: "cumulative_duration" }, [
                _vm._v("观看时长")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.video_learning_time)
                ),
                _c("span", { staticClass: "hours" }, [_vm._v("小时")])
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计时长" +
                        _vm._s(
                          _vm.data.total_learning_statistics.video_learning_time
                        ) +
                        "小时"
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas", staticStyle: { opacity: "0" } })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "homework_detail" }, [
          _c("p", { staticClass: "live_title" }, [
            _c("span", { staticClass: "icon" }, [
              _c("img", {
                attrs: { src: require("../../../static/images/homework.png") }
              }),
              _vm._v("作业"),
              _vm.ua
                ? _c("span", { staticClass: "supplementary" }, [
                    _vm._v("可登录学习APP及时处理未完成作业")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.isApp
              ? _c(
                  "span",
                  { staticClass: "godetail", on: { click: _vm.goHomeWork } },
                  [
                    _vm._v("详情"),
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/detail.png")
                      }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "partition_statistics" }, [
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("完成数")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.homework_finish_total) +
                    "/" +
                    _vm._s(_vm.data.learning_statistics.homework_total)
                )
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计完成" +
                        _vm._s(
                          _vm.data.total_learning_statistics
                            .homework_finish_total
                        ) +
                        "/" +
                        _vm._s(
                          _vm.data.total_learning_statistics.homework_total
                        )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("正确率")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(_vm._s(_vm.data.learning_statistics.homework_rate))
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "历史正确率" +
                        _vm._s(_vm.data.total_learning_statistics.homework_rate)
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("平均分")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(_vm._s(_vm.data.learning_statistics.homework_score)),
                _c("span", { staticClass: "hours" }, [_vm._v("分")])
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "历史平均分" +
                        _vm._s(
                          _vm.data.total_learning_statistics.homework_score
                        )
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mock_detail" }, [
          _c("p", { staticClass: "live_title" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm.isApp
              ? _c(
                  "span",
                  { staticClass: "godetail", on: { click: _vm.goMock } },
                  [
                    _vm._v("详情"),
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/detail.png")
                      }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "partition_statistics" }, [
            _c("div", { staticClass: "canvas" }, [
              _c("p", [_vm._v("完成数")]),
              _vm._v(" "),
              _c("p", { staticClass: "finish_num" }, [
                _vm._v(
                  _vm._s(_vm.data.learning_statistics.mock_finish_total) +
                    "/" +
                    _vm._s(_vm.data.learning_statistics.mock_total)
                )
              ]),
              _vm._v(" "),
              _vm.data.total_learning_statistics
                ? _c("p", [
                    _vm._v(
                      "累计完成" +
                        _vm._s(
                          _vm.data.total_learning_statistics.mock_finish_total
                        ) +
                        "/" +
                        _vm._s(_vm.data.total_learning_statistics.mock_total)
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "unaccomplished" }, [
      _c("img", {
        attrs: { src: require("../../../static/images/havent.png") }
      }),
      _vm._v("你还有学习内容未完成，请下滑查看")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "live_title" }, [
      _c("span", { staticClass: "icon" }, [
        _c("img", {
          attrs: { src: require("../../../static/images/comment.png") }
        }),
        _vm._v("教师点评")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "introduce" }, [
      _c("span"),
      _vm._v("课程完成：直播观看达45分钟或回放观看达50%")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("../../../static/images/shipin.png") }
      }),
      _vm._v("视频")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", { attrs: { src: require("../../../static/images/mock.png") } }),
      _vm._v("模考")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ad3530f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad3530f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/report.vue
// module id = null
// module chunks = 